import React from 'react'
import PropTypes from 'prop-types'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelActions,
  SvgIcon,
} from '@material-ui/core'
import { mdiChevronDown } from '@mdi/js'

import TableView from '../controls/TableView'
import CsvDownload from '../controls/CsvDownload'

class TimeseriesDataTableView extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    valueFormatter: PropTypes.func.isRequired,
  }

  render() {
    const { title, ...props } = this.props
    const expandIcon = (
      <SvgIcon>
        <path d={mdiChevronDown} />
      </SvgIcon>
    )

    return (
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={expandIcon}>
          {title}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <TableView {...props} />
        </ExpansionPanelDetails>
        <ExpansionPanelActions>
          <CsvDownload {...props} color="primary" />
        </ExpansionPanelActions>
      </ExpansionPanel>
    )
  }
}

export default TimeseriesDataTableView
